module.exports = __webpack_public_path__ + "static/media/independent.fd8616ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/independent.png
// module id = 1811
// module chunks = 147